module.exports = __webpack_public_path__ + "img/V.dc874415.png";